export const AppState = {
  data: {
    screen: {
      width: window.innerWidth
    },
    loggedIn: false
  }
};